//  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
import SpeakersConfiguration from '@/configurations/content/mashroom/speakers'
//  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
import PartnersConfiguration from '@/configurations/content/mashroom/partners' // @/configurations/content/partners-dark для темной темы

export default {
  pageTitle: 'Первая отраслевая конференция по инженерному анализу для атомной отрасли',
  logo: {
    image: require('@/assets/logo/T1 integration main.svg'), // @/assets/logo/logo-white.svg для темной темы
    alt: 'Mashroom logo'
  },
  pageBackgroundImage: require('@/assets/background/background втб.jpg'), // путь до кастомного фона
  aboutActivity: {
    name: 'Первая отраслевая конференция по инженерному анализу для атомной отрасли',
    description: [
      '12 ноября Т1 Интеграция приглашает вас присоединиться к конференции по инженерному анализу для атомной отрасли.',
      '<uh> <li>Поделимся многолетним опытом по импортозамещению за рубежом</li> <li>Расскажем о достижениях советской инженерной школы, которые лежат в основе наших историй успеха</li> <li>Разберем практические примеры наших пользователей в атомной отрасли</li>',
      '<b> Выдающиеся результаты достигаются благодаря выдающимся пользователям </b>',
      '',
      '',
      '',
      '',
      '',
      ''
    ],
    date: '12.11.2024',
    time: '12:00-18:00'
  },
  activities: [
    {
      tabName: 'Выберите', // название таба, при многозальном мероприятии
      items: [
        {
          hash: 'enwaXfMp',
          id: 723,
          hallName: 'Основной шоурил' // название зала
        }
      ]
    }
  ],
  player: {
    title: 'Трансляция' // заголовок блока "Плеер"
  },
  schedule: {
    title: 'Расписание' // заголовок блока "Расписание"
  },
  speakers: {
    //  Закомментируйте строку ниже если блок "Спикеры" не будет использоваться
    items: SpeakersConfiguration,
    title: 'Спикеры', // заголовок блока "Спикеры"
    shape: 'circle' // форма фотографий спикеров ('square' - квадрат, 'circle' - круг)
  },
  imageBlock: {
    title: 'Как добраться', // заголовок Блока с картинкой (оставить пустым (''), если не нужен)
    image: require('@/assets/image-block/Screenshot_52.png'), // путь до изображения для блока с картинкой
    items: [
      '',
      '<a href="https://yandex.ru/maps/org/arena/175006051329/?ll=37.570711%2C55.789425&z=16.92" target="_blank">Бизнес-центр «Арена», Москва, Ленинградский пр-т., 36, стр. 41</a>',
      '',
      '',
      ''
    ]
  },
  info: {
    title: 'О компании', // заголовок Текстового блока (оставить пустым (''), если не нужен)
    items: [
      '<b>Т1 Интеграция</b> входит в <b>Холдинг Т1</b>, является одним из лидеров рынка системной интеграции в России, обладает большим набором компетенций, подтверждённых официальными статусами от ключевых мировых и отечественных производителей и разработчиков. Компания создана в 1992 году. Продуктовый портфель компании включает свыше 130 продуктов и услуг в области системной интеграции, промышленного инжиниринга, информационной безопасности, сетевых технологий и пр. Компанией реализовано более 2000 проектов в интересах заказчиков – государственных структур и крупнейших компаний ключевых отраслей экономики.',
      '<b>Центр компетенций по вычислительным комплексам</b> оказывает услуги по реализации проектов полного цикла, связанных с построением и модернизацией ИТ-инфраструктуры заказчиков. <a href="https://t1.ru/competencies/item/vychislitelnye-kompleksy//" target="_blank">Подробнее</a>',
      '<b>«Базис»</b> — один из ведущих российских разработчиков программных продуктов для оказания облачных услуг и платформы динамической инфраструктуры.',
      '<br>',
      '<p><hr / color="#00AAE6"><br>',
      '<p>В наших аккаунтах: новости, кейсы, тренды и экспертная аналитика.',
      '<a href="https://habr.com/ru/companies/T1Holding/articles/"><img style="margin-right:50px" src="assets/image-block/habr.png" </a><a href="https://t.me/T1Holding"><img style="margin-right:50px" " src="assets/image-block/tg.png" </a>',
      '<p>Подписывайтесь!'
    ]
  },
  partners: {
    //  Закомментируйте строку ниже если блок "Партнеры" не будет использоваться
    items: PartnersConfiguration,
    title: 'Наши клиенты' // заголовок блока "Партнёры"
  },
  footer: {
    copyright: '© Холдинг Т1,',
    phone: ''
  }
}
